import { FlowchartStep } from './flowchart-step.model';

export class FlowchartLink {
	type = 'FlowchartLink';
	id: string;
	fromStep: FlowchartStep;
	toStep: FlowchartStep;
	line: any;
	offsetStart: number;
	offsetEnd: number;
	isDropoff: boolean;
	statsIndex: number;
	d: string;

	constructor(props: any) {
		this.id = props.id || props.toStep.id;
		this.line = {
			start: {},
			end: {},
		};
		this._update(props);
	}

	update(props: any) {
		this._update(props);
	}


	// getX(step: any, updateStart?: boolean) {
	// 	return step ? step.x + (updateStart ? 10 : 50) : ev.clientX - this.svgWrapper.nativeElement.getBoundingClientRect().left +
	// 		( this.svgWrapper.nativeElement as any ).offsetLeft;
	// }

	// getY(ev: MouseEvent, step?: any, updateStart?: boolean) {
	// 	return step ? step.y + 30 : ev.clientY - this.svgWrapper.nativeElement.getBoundingClientRect().top +
	// 		( this.svgWrapper.nativeElement as any ).offsetTop;
	// }
	updateDropoffLine(line: any) {
		const radius = 100;
		line.end.x = line.start.x + radius;
		line.end.y = line.start.y + radius;

		const s = line.start;
		const e = line.end;

		if (s.x && s.y && e.x && e.y) {
			// from left to right
			line.d = `M${s.x},${s.y // start point of the line and first point of first bezier line x,y
			} C${e.x - (e.x - s.x) / 2},${s.y // second point of first bezier line x,y
			}  ${e.x},${e.y - (e.y - s.y) / 2 // first point of the second bezier line x,y
			}  ${e.x},${e.y}`; // end point of the line and second point of second bezier line x,y
		}
		this.d = line.d;
	}

	updateLine(props: any) {
		if (!props.fromStep || !props.toStep) {
			return false;
		}
		const line = this.line;

		line.start.x = props.fromStep.x + props.fromStep.width - 5;
		if (props.offsetStart || props.offsetStart === 0) {
			line.start.y = props.fromStep.y + props.offsetStart;
		} else {
			line.start.y = props.fromStep.y + (props.fromStep.height / 2);
		}

		if (props.isDropoff) {
			return this.updateDropoffLine(line);
		}
		line.end.x = props.toStep.x;
		if (props.offsetEnd || props.offsetEnd === 0) {
			line.end.y = props.toStep.y + props.offsetEnd;
		} else {
			line.end.y = props.toStep.y + (props.fromStep.height / 2);
		}

		const s = line.start;
		const e = line.end;

		// check if the line goes to a step further to the left of the fromStep
		line.goesBack = props.toStep.x < props.fromStep.x;
		line.goesUp = props.toStep.y < props.fromStep.y;

		// halfway points
		// let h = {
		// 	x: e.x - s.x,
		// 	y: e.y - s.y
		// };
		// https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Paths
		if (s.x && s.y && e.x && e.y) {
			if (s.x < e.x) {
				// from left to right
				line.d = `M${s.x},${s.y // start point of the line and first point of first bezier line x,y
				} C${e.x - (e.x - s.x) / 2},${s.y // second point of first bezier line x,y
				} ${s.x + (e.x - s.x) / 2},${e.y // first point of the second bezier line x,y
				} ${e.x},${e.y}`; // end point of the line and second point of second bezier line x,y

				// from left to right with min max
				// line.d = `M${ s.x },${ s.y // start point of the line and first point of first bezier line x,y
				// } C${ e.x - ( Math.max( e.x - s.x, 500) ) / 2 },${ s.y // second point of first bezier line x,y
				// } ${ s.x  + ( Math.min( e.x - s.x, -500) ) / 2 },${ e.y // first point of the second bezier line x,y
				// } ${ e.x },${ e.y }`; // end point of the line and second point of second bezier line x,y
			} else {
				// from right to left
				line.d = `M${s.x},${s.y
				} C${s.x + (s.x - e.x) / 2},${s.y
				} ${e.x - (s.x - e.x) / 2},${e.y
				} ${e.x},${e.y}`;

				// check if the toStep is further to the left then the start step ("buitenom terug lijntjes")
				// line.d = `M${ s.x },${ s.y
				// } C${ s.x + ( s.x - e.x ) / 2 },${ line.goesBack ? (line.goesUp ? s.y + 400 : s.y - 400) : s.y
				// } ${ e.x  - ( s.x - e.x ) / 2 },${ line.goesBack ? (line.goesUp ? e.y + 400 : e.y - 400) : e.y
				// } ${ e.x },${ e.y }`;

				// from right to left with min max
				// line.d = `M${ s.x },${ s.y
				// } C${ s.x + ( Math.max( s.x - e.x, 500) ) / 2 },${ s.y
				// } ${ e.x  - ( Math.max( s.x - e.x, 500) ) / 2 },${ e.y
				// } ${ e.x },${ e.y }`;
			}

		}
		this.d = line.d;
	}

	private _update(props: any) {
		Object.keys(props).forEach(prop => this[prop] = props[prop]);
		this.updateLine(props);
	}
}
